<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2 ml">
                    فیلتر داده‌ها
                </CButton>
                <CButton @click="redirect_to(`/support/new`)"
                    v-show="$store.state.perms.can_start_new_conversation" color="primary" class="mb-2">
                    ایجاد مکالمه جدید</CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های فیلتر</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>تاریخ ایجاد</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.created_at.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.created_at.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>آخرین به‌روزرسانی</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.last_update.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.last_update.inv}}</small>
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;get();" class="ml" color="primary">فیلتر</CButton>
                                <CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>لینک‌ها</strong>
                        <div class="card-header-actions">
                            تعداد: {{row_count}}
                        </div>
                        </CCardHeader>
                    <CCardBody>
                        <CCol sm="5">
                            <CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
                                {value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count" placeholder="تعداد سطرها" @change="limit=$event.target.value" />
                        </CCol>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #from_user="data">
                                <td>
                                    <router-link :to="`/profile/${data.item.user_id}`">{{data.item.from_user}}</router-link>
                                </td>
                            </template>
                            <template #is_active="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.is_active)">
                                        {{data.item.is_active}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #is_answered="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.is_answered)">
                                        {{data.item.is_answered}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #action="data">
                                <td>
                                    <template>
                                        <div class="flex-container">
                                            <div @click="redirect_to(`/support/${data.item.id}/messages`)"
                                                v-c-tooltip.hover="'پیام‌ها'">
                                                <CIcon name="cilEnvelopeOpen" size="lg"/>
                                            </div>
                                            <div v-show="data.item.can_close"
                                                @click="close_modal=true;id=data.item.id"
                                                v-c-tooltip.hover="'بستن مکالمه'">
                                                <CIcon name="cilX" size="lg"/>
                                            </div>
                                        </div>
                                    </template>
                                </td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="دقت کنید"
            size="sm"
            color="primary"
            :show.sync="close_modal"
            >
            <p>آیا برای بستن مکالمه اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="close_modal=false" color="secondary">خیر</CButton>
                <CButton @click="close_conversation" color="primary">بله</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data () {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'title', label: 'موضوع'},
                { key: 'from_user', label: 'کاربر' },
                { key: 'is_active', label: 'وضعیت مکالمه' }, 
                { key: 'is_answered', label: 'وضعیت پیام' }, 
                { key: 'messages_count', label: 'تعداد پیام‌ها' },
                { key: 'unread_messages', label: 'پیام‌های خوانده نشده' },
                { key: 'created_at', label: 'تاریخ ایجاد' },
                { key: 'last_update', label: 'آخرین به‌روزرسانی' },
                { key: 'action', label: 'عملیات' }
            ],
            collapse: false,
            form: {
                user_id: { val: '', inv: '', v: { max: 8 } },
                created_at: { val: '', inv: '', v: { max: 16} },
                last_update: { val: '', inv: '', v: { max: 16 } },
            },
            filter: false,
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            users: [],
            close_modal: false,
            id: 0,
        }
    },
    watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
    mounted(){
        this.get();
        this.get_users();
    },
    methods: {
        get_users(){
            this.axios.get('users/?type=view_user_conversations')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        get_badge (status) {
            switch (status) {
                case 'تکمیل شده': return 'secondary';
                case 'پاسخ داده شده': return 'success';
                case 'در انتظار پاسخ': return 'info';
                case 'در حال مکالمه': return 'primary';
            }
        },
        get() {
            if (this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            if (key == 'created_at' || key == 'last_update') {
                                filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            } else {
                                filter += `&${key}=` + this.form[key].val;
                            }
                        }
                    }
                }
                this.axios.get('conversations/' 
                    + '?count=1' 
                    + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                        this.offset = 0;
                        if(this.page != 1){
                            this.offset = (this.page * this.limit) - this.limit;
                        }
                    })
                .finally(() => {
                    this.axios.get('conversations/' 
                        + '?limit=' + this.limit 
                        + '&offset=' + this.offset 
                        + '&from_user_info=1' 
                        + filter)
                        .then(res => {
                            res.data.map(val => {
                                val.from_user = `${val.from_user_info.first_name} ${val.from_user_info.last_name}`;
                                val.user_id = val.from_user_info.id;
                                if(val.is_active == true){
                                    val.is_active = 'در حال مکالمه';
                                    if(val.is_answered == true){
                                        val.is_answered = 'پاسخ داده شده'
                                    } else {
                                        val.is_answered = 'در انتظار پاسخ'
                                    }
                                } else {
                                    val.is_active = 'تکمیل شده';
                                    val.is_answered = 'تکمیل شده'
                                }
                                if(val.last_update == '0001-01-01T00:00:00Z'){
                                    val.last_update = '---';
                                } else {
                                    val.last_update = this.$moment(val.last_update, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                                }
                                val.created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                            });
                            this.items = res.data;
                        })
                })
            }
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
        close_conversation() {
            const data = new FormData();
            data.set('id', this.id);
			this.axios.put('conversations/', data)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'بستن مکالمه با موفقیت انجام شد.'
                });
				this.close_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
                });
                this.close_modal = false;
			})
        },
        redirect_to(route) {
            this.$router.push(route);
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_user_conversations_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
